export default "__VITE_ASSET__Bi8ov9xA__"